import { Select } from "antd";
import Search from "antd/es/input/Search";
import React, { FC } from "react";
import { PaymentForm, Product } from "tm-shared/types";

import DropdownFilters from "../FastFilters";
import {
    InputWrapper,
    StyledContainer,
    StyledTopContainer,
} from "./SaleFiltersPanel.styled";

const formList = [
    {
        value: PaymentForm.Cash1,
        label: "Form 1",
    },
    {
        value: PaymentForm.Card2,
        label: "Form 2",
    },
];

interface SaleFiltersPanelProps {
    query: string;
    onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;

    selectedForm: PaymentForm | null;
    onFormChange: (value: PaymentForm) => void;

    products: { [barcode: string]: Product };
    onFilteredChange: (filtered: Product[]) => void;
}

export const SaleFiltersPanel: FC<SaleFiltersPanelProps> = ({
    query,
    onSearch,
    selectedForm,
    onFormChange,
    products,
    onFilteredChange,
}) => {
    return (
        <StyledContainer>
            <StyledTopContainer>
                <InputWrapper>
                    <Search
                        placeholder="Пошук"
                        defaultValue={query}
                        onChange={onSearch}
                        allowClear
                        size="large"
                    />
                </InputWrapper>
                <Select
                    options={formList}
                    value={selectedForm}
                    onChange={onFormChange}
                    placeholder="Форма"
                    size="large"
                />
            </StyledTopContainer>

            <DropdownFilters
                products={products}
                onFilteredChange={onFilteredChange}
            />
        </StyledContainer>
    );
};
